import React, {useRef, useState, useEffect, useCallback} from 'react'
import Header from '../components/Header'
import Testimonial from '../components/Testimonial'
import Footer from '../components/Footer'
import Client from '../components/Client'
import mutedVideo from '../media/junnasolar.mp4'
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ClipLoader from "react-spinners/ClipLoader"; 
import { Link } from 'react-router-dom'
import Autocomplete from "react-google-autocomplete";
import ReCAPTCHA from 'react-google-recaptcha';
import usePageSEO from '../hooks/usePageSEO'
import Loader from '../components/Loader'
import Slider from 'react-slick'

const Home = () =>{
  const [loading, setLoading] = useState(true);
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const mapApiKey = process.env.REACT_APP_GOOGLE_PLACE_API_KEY;
  const recaptchaKey = process.env.REACT_APP_GOOGLE_RECAPTCHA_KEY;
  const siteUrl = process.env.REACT_APP_BACKEND_URL;

  const [solFirstName, setSolFirstName] = useState("");
  const [solLastName, setSolLastName] = useState("");
  const [solPhone, setSolPhone] = useState("");
  const [solEmail, setSolEmail] = useState("");
  const [solLocation, setSolLocation] = useState("");    
  const [errors, setErrors] = useState({});
  const [isChecked, setIsChecked] = useState(true);
  const [disableButton, setDisableButton] = useState(false);
  const [spinnerClass, setSpinnerClass] = useState('invisible');
  const [isVisible, setIsVisible] = useState('visible');
  const [showMessage, setShowMessage] = useState('invisible');  
  const [msg, setMsg] = useState("");

  const recaptchaRef = useRef(null);
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);  
  const [isValidCaptcha, setIsValidCaptcha] = useState("");

  const [slider, setSlider] = useState("");
  const [achievement, setAchievement] = useState("");
  const [product, setProduct] = useState([]);
  const [solution, setSolution] = useState([]);
  const [productpage, setProductpage] = useState("");
  const [solutionpage, setSolutionpage] = useState("");
  const [metaTitle, setMetaTitle] = useState('');
  const [metaDescription, setMetaDescription] = useState('');
  const [aboutpagedata, setAboutPagedata] = useState('');

  
  const [testimonial, setTestimonial] = useState([]);
  const [clientLogo, setClientLogo] = useState([]);

  const handleCaptchaChange = (token) => {
    setIsCaptchaVerified(!!token);
  };

  const resetCaptcha = () => {
    recaptchaRef.current?.reset();
    setIsCaptchaVerified(false);
    setIsValidCaptcha("Valid");
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors({});
      return;
    }     
  };

  const getInitialState = () => {
    const value = '';
    return value;
  };
  const [enquiry, setEnquiry] = useState(getInitialState);

  const dropdownHandleChange = (e) => {
    setEnquiry(e.target.value);
  };  
 
  const toggleDisableButton = () => {
    setDisableButton(!disableButton);
    setIsChecked(!isChecked);
  };  

  const changeClass = () => {
    setSpinnerClass('visible');
    setIsVisible('invisible');
  };

// Validation function for email and password
  const validateForm = () => {
    const errors = {};
    if (!solFirstName) {
        errors.solFirstName = "First name is required";
    }
    if (!solLastName) {
        errors.solLastName = "Last name is required";
    }
    if (!solPhone) {
        errors.solPhone = "Contact number is required";
    }    
    if (!solLocation) {
        errors.solLocation = "Location is required";
    } 
    if (isCaptchaVerified === false) {
      errors.isValidCaptcha = "Please verify the CAPTCHA before submitting";
    }
    return errors;
  };
  
  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }  

    if (!isCaptchaVerified) {
      return;
    }
        
    changeClass(); 

    const apiUrl = apiBaseUrl + `sendmail?form_type=3&enquiry_type=${enquiry}&first_name=${solFirstName}&last_name=${solLastName}&contact_number=${solPhone}&email=${solEmail}&location=${solLocation}&message=`;
    //console.log('API URL:',apiUrl);
    await axios.get(apiUrl).then((res)=>{
        setSpinnerClass('invisible');
        setIsVisible('visible');
        setMsg(res.data.msg);
        //console.log('Send Data:', res);
        if (res.data.success === true) {
            toast("Data sent successfully");
            setSolFirstName("");
            setSolLastName("");
            setSolPhone("");
            setSolEmail("");
            setSolLocation("");
            setEnquiry("");
            setShowMessage('visible');
        } else {
            toast(res.data.error || "Mail not sent");
        }        
      }).catch((err)=>{
        //console.log('Invalid Email :', err);
        setSpinnerClass('invisible');
        setIsVisible('visible');
        setShowMessage('visible');
        toast("Something went wrong. Please try again later.");
    })

  };

  const homeScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Optional, for smooth scrolling
    });
  }; 

  const videoRef = useRef();
  const [video, setVideo] = useState(null);

  const fetchPagedata = useCallback(() => {
    return axios.get(apiBaseUrl+`homepage`).then((res) => {
      setMetaTitle(res.data.homepage.meta_title);
      setMetaDescription(res.data.homepage.meta_description);
      setSlider(res.data.slider);
      setVideo(res.data.slider.video);
      setAchievement(res.data.achievement);
      setAboutPagedata(res.data.aboutpage);
      setProductpage(res.data.productpage);
      setProduct(res.data.products);
      setSolutionpage(res.data.solutionpage)
      setSolution(res.data.solutions);

      setTestimonial(res.data.testimonial);
      setClientLogo(res.data.clients);
    });
  },[]); 

  useEffect(() => {
    setTimeout(() => {
      fetchPagedata()
      videoRef.current?.load();
      setLoading(false);
    }, 2000);
  }, [fetchPagedata, video]);

  function createMarkup(data) {
    return { __html: data };
  }

  usePageSEO({
    title: `${metaTitle}`,
    description: `${metaDescription}`
  })    

  const testimonialsettings = {
      dots: true,
      autoplay: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false
  };  
  const clientsettings = {
        dots: false,
        autoplay: true,
        infinite: true,
        speed: 500,
        slidesToShow: 9,
        slidesToScroll: 1,
        arrows: false,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 5,
              },
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 3,
              },
            },
          ],        
  }; 

  return (
    <>
    <Header/>

    { loading && (
      <Loader />
    )}	

    {/* ------------------ HOME BANNER SECTION ------------------*/}
    <section className="section-banner1">
      <div className="col-sm-12">
        <div className="row">
          <video ref={videoRef} autoPlay muted loop width="100%">
            <source src={video} type="video/mp4" />
          </video>
        </div>
      </div>		
      <div className="container">
        <div className="row">
            <div className="banner-contant">
                <div className="col-sm-2"></div>
                <div className="col-md-4 col-sm-6 ">
                  <div className="banner-content wow slideInUp animated" 
                    data-wow-duration="1s" 
                    data-wow-delay="0s" 
                    style={{
                        visibility: 'visible', 
                        animationDuration: '1s', 
                        animationDelay: '0s', 
                        animationName: 'slideInUp'
                        }}>  
                        <div  />            
                        <h2 className='visible-md visible-lg hidden-xs' dangerouslySetInnerHTML={createMarkup(slider?.desktop_heading)}></h2>
                        <h2 className='hidden-md hidden-lg visible-xs' dangerouslySetInnerHTML={createMarkup(slider?.mobile_heading)}></h2>
                        <p dangerouslySetInnerHTML={createMarkup(slider?.description)}></p>
                    </div>
                </div>
                <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12"> 
                    <div className="appointment-form-wrapper clearfix wow fadeInUp animated" 
                      style={{
                        visibility: 'visible', 
                        animationName: 'fadeInUp'
                      }}>
                        <div className="appointment-form-heading">
                        <h3>Schedule Free Consultation for Solar Solutions</h3>
                        <p>We're excited to connect with you! Please submit your information and we'll get back to you promptly.</p>
                        </div>
                        <ToastContainer/>
                        <form className="appoinment-form home" onSubmit={handleSubmit}> 
                            <div className="form-group col-md-12">
                                <div className="select-style">
                                <label>Enquiry type</label>
                                <select 
                                  className="form-control" 
                                  name="enquiry_type"
                                  value={enquiry}
                                  onChange={dropdownHandleChange}>                                  
                                  <option value={''}>Choose Solution</option>
                                  <option value={'Residential'}>Residential</option>
                                  <option value={'Housing Society'}>Housing Society</option>
                                  <option value={'Commercial'}>Commercial</option>
                                  <option value={'Industrial'}>Industrial</option>
                                  <option value={'Institutional'}>Institutional</option>
                                  <option value={'Floating'}>Floating</option>
                                  <option value={'Other'}>Others</option>
                                </select>
                                </div>
                            </div>
                            <div className="form-group col-md-6">
                                <label>First name <span className="text-danger"><strong>*</strong></span></label>
                                <input 
                                    className="form-control" 
                                    placeholder="First name" 
                                    type="text" 
                                    name="sol_first_name"
                                    value={solFirstName}
                                    onChange={(e) => setSolFirstName(e.target.value)}
                                    autoComplete="false"                            
                                    required/>
                                    {errors.solFirstName && <span className="error-message">{errors.solFirstName}</span>}
                            </div>
                            <div className="form-group col-md-6">
                                <label>Last name <span className="text-danger"><strong>*</strong></span></label>
                                <input 
                                    className="form-control" 
                                    placeholder="Last name" 
                                    type="text" 
                                    name="sol_last_name"
                                    value={solLastName}
                                    onChange={(e) => setSolLastName(e.target.value)}
                                    autoComplete="false"                            
                                    required/>
                                    {errors.solLastName && <span className="error-message">{errors.solLastName}</span>}
                            </div>                                
                            <div className="form-group col-md-12">
                                <label>Contact number <span className="text-danger"><strong>*</strong></span></label>
                                <input 
                                    className="form-control" 
                                    placeholder="Contact number" 
                                    type="text"
                                    name="sol_contact_number"
                                    maxLength={10}
                                    value={solPhone}
                                    onChange={(e) => setSolPhone(e.target.value)}
                                    autoComplete="false"                            
                                    required/>
                                    {errors.solPhone && <span className="error-message">{errors.solPhone}</span>}
                            </div>
                            <div className="form-group placeholder-wrap icon-form-outline col-md-12">
                              <label>Solar installation location <span className='text-danger'>*</span></label>
                              <i className="left fa fa-search"></i>
                              <Autocomplete
                                apiKey={mapApiKey}
                                name="sol_location" 
                                className="form-control location-input" 
                                type="text"
                                placeholder='Solar installation location' 
                                onPlaceSelected={(place) => {
                                  //console.log(place?.formatted_address);
                                  setSolLocation(place?.formatted_address)
                                }}
                                options={{
                                  types: ["(regions)"],
                                  componentRestrictions: { country: "in" },
                                }}
                                onChange={(e) => setSolLocation(e.target.value)}
                                defaultValue={solLocation}
                                required/>
                              <i className="right fa fa-map-marker"></i>
                              {errors.solLocation && <span className="error-message">{errors.solLocation}</span>}
                           </div>                    
                            <div className="form-group col-md-12">
                                <label>Email</label>
                                <input 
                                    className="form-control" 
                                    placeholder="Email" 
                                    type="email"
                                    name="sol_email"
                                    value={solEmail}
                                    onChange={(e) => setSolEmail(e.target.value)}
                                    autoComplete="false"/>
                            </div>
                            
                            <div className="form-group col-md-10 col-sm-10 col-lg-10 col-xs-9">
                              <ReCAPTCHA
                                ref={recaptchaRef}
                                sitekey={recaptchaKey}
                                className="input-control google-recaptch-wrapper"
                                onChange={handleCaptchaChange}
                              />  
                            </div>
                            <div className="col-md-2 col-sm-2 col-lg-2 col-xs-3 text-center">
                              <span 
                                className="form-control refresh-btn-wrapper" 
                                onClick={resetCaptcha}><i className="fa fa-refresh"></i></span>
                            </div>
                            {errors.isValidCaptcha && 
                            <>
                            <div className="form-group col-md-12">
                              <span className="error-message">{errors.isValidCaptcha}</span>
                            </div>
                            </>
                            }

                            <div className="form-group col-md-12">
                                <label><input 
                                    type="checkbox" 
                                    name="chkPolicy"
                                    onChange={toggleDisableButton}
                                    checked = { isChecked } 
                                    required /> You agree to our <Link to="/privacy-policy" onClick={homeScrollToTop}>privacy policy</Link>.</label>
                            </div>            
                            <div className="form-group col-md-12 col-sm-12 col-xs-12 text-center">
                                <button 
                                    className={`${isVisible} btn btn-lg btn-appointment-submit`}
                                    type="submit" 
                                    disabled={disableButton}>
                                      Get Call Back
                                </button>                                    
                                <span className={`${spinnerClass} btn btn-lg btn-appointment-submit`}>
                                    <ClipLoader
                                        loading={true}
                                        size={30}
                                        color={"#ffffff"}/>                            
                                </span>                                    
                            </div>
                            {!!(msg) && (
                              <div className="form-group col-md-12 col-sm-12 col-xs-12 custom-message text-center">
                                <span className={`${showMessage} text-center text-success`}>{msg}</span>  
                              </div>
                            )}
                        </form>
                    </div> 
                </div>
                <div className="col-sm-2"></div>
            </div>
        </div>
      </div>
    </section>

    {/* ------------------ ABOUT US SECTION ------------------*/}
    <section className="section-content-block">

      <div className="container wow fadeIn">
        
        <div className="row">
            <div className="col-md-offset-2 col-md-8 col-sm-12 text-center">    
                <p className="our-experience">                             
                   {achievement?.name}
                </p>
                <div className="about-us-intro col-lg-offset-1 col-lg-10 col-sm-12" dangerouslySetInnerHTML={createMarkup(achievement?.description)}></div>                            
            </div>
        </div>

        <div className="container">
          <div className="row1 text-center margin-top-32 solar-advantage ">
            <ul>
              <li className=""> 
                  <div className="highlight-box">
                    <img src="/images/Clip path group.svg" alt="" />
                    <p className="highlight-text">{achievement?.value1}</p>
                    <span>{achievement?.label1}</span>
                  </div>
              </li>
              <li className=""> 
                  <div className="highlight-box">
                    <img src="/images/Group.svg" alt="" />
                    <p className="highlight-text">{achievement?.value2}</p>
                    <span>{achievement?.label2}</span>
                  </div>
              </li>
              <li className=""> 
                  <div className="highlight-box">
                    <img src="/images/users-01.svg" alt="" />
                    <p className="highlight-text">{achievement?.value3}</p>
                    <span>{achievement?.label3}</span>
                  </div>
              </li>
              <li className=""> 
                  <div className="highlight-box">
                    <img src="/images/Plant.png" alt="" />
                    <p className="highlight-text">{achievement?.value4}</p>
                    <span>{achievement?.label4}</span>
                  </div>
              </li>
              <li className=""> 
                  <div className="highlight-box">
                    <img src="/images/award-03.svg" alt="" />
                    <p className="highlight-text">{achievement?.value5}</p>
                    <span>{achievement?.label5}</span>
                  </div>
              </li>
            </ul>
          </div>
        </div>

      </div> 

    </section>
    <div className="container"><hr/></div>

    {/* ------------------ LAYOUT SECTION ------------------*/}

    <section className="section-content-block">
      <div className="container">
          <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-12">                       
                <div className="about-us-intro">
                    <p className="blue">{aboutpagedata?.name}</p>
                    <h2 className="heading">{aboutpagedata?.page_heading}</h2>
                    <p dangerouslySetInnerHTML={createMarkup(aboutpagedata?.description)}></p>
                </div>                            
              </div> 
              <div className="col-lg-6 col-md-6 col-sm-12 text-right">
                  <img src={`${siteUrl}${aboutpagedata?.additional_image}`} alt={aboutpagedata?.name} />               
              </div>
          </div>
      </div> 
    </section>
    <div className="container"><hr/></div>

		<section className="section-content-block">
      <div className="container">
        <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 text-center">                       
                <div className="about-us-intro">
                  <p className="blue">{productpage?.name}</p>
                  <h2 className="heading col-lg-offset-3 col-lg-6 col-md-12 col-sm-12 col-xs-12">{productpage?.page_heading}</h2>
                  <p className='col-lg-offset-2 col-lg-8 col-sm-12' dangerouslySetInnerHTML={createMarkup(productpage?.description)}></p>
                </div>                            
            </div> 
          </div>
				<div className="row">
          {product.map((item, index)=>{
            return(
              <div className="col-lg-4 col-md-4 col-sm-12 text-center" key={index}>                       
                  <div className="Products">
                      <img src={`${siteUrl}${item?.image}`} alt={item?.name} /> 
                      <h4 className="heading">{item?.name}</h4>
                      <p dangerouslySetInnerHTML={createMarkup(item?.description)}></p>
                  </div>                            
              </div> 
            )
          })}

					  <div className="col-lg-12 col-md-12 col-sm-12 text-center">
              <Link to="/products" className="btn btn-button margin-top-60" onClick={homeScrollToTop}>Know more</Link>  
            </div>
					
        </div>
      </div> 
    </section>

    <div className="container"><hr/></div>
    
    <section className="section-content-block">
      <div className="container">
          <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 text-center">                       
                <div className="about-us-intro">
                    <p className="blue">{solutionpage?.name}</p>
                    <h2 className="heading col-lg-offset-3 col-lg-6 col-md-12 col-sm-12 col-xs-12">
                      {solutionpage?.page_heading}
                    </h2>
                    <p className='col-sm-12' dangerouslySetInnerHTML={createMarkup(solutionpage?.description)}></p>
                </div>                            
              </div> 
          </div>
          <div className="row">
          {solution.map((item, index)=>{
            return(            
              <div className="col-lg-4 col-md-4 col-sm-12 text-center" key={index}>                       
                <div className="Products">
                  <img src={`${siteUrl}${item?.image}`} alt={item?.name} />
                  <h4 className="heading">{item?.name}</h4>
                  <p dangerouslySetInnerHTML={createMarkup(item?.description)}></p>
                  </div>                            
              </div> 
              )
            })}

              <div className="col-lg-12 col-md-12 col-sm-12 text-center">
                <Link to="/solutions" onClick={homeScrollToTop} className="btn btn-button margin-top-60">Know more</Link>
              </div>

          </div>
      </div> 
    </section>

    {(testimonial.length) > 0 && (
    <>
    <div className="container"><hr/></div>
    <section className="section-content-block">
      <div className="container">
        <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 text-center">                       
                <div className="about-us-intro">
                    <p className="blue">Testimonial</p>
                    <h2 className="heading">What our Customers Say</h2>
                    <p>&nbsp;</p>
                </div>                            
              </div> 
        </div>        
        <div className="row">     
         <div className="testimonial-container col-lg-offset-1 col-lg-10 col-md-12 col-sm-12 col-xs-12 text-center">
          <Slider {...testimonialsettings}>
            {testimonial.map((item, index) => {
                return (              
                <Testimonial 
                  key={index}
                  prm={{
                    name: item?.author_name,
                    description: item?.description
                  }}
                />
                )
            })}          
            </Slider>
        </div>
        
        </div>
      </div>
    </section>
    </>
    )}

    {(clientLogo.length) > 0 && (   
    <> 
      <div className="container"><hr/></div>
      <section className="section-content-block">
          <div className="col-lg-12 col-md-12 col-sm-12 text-center">                       
              <div className="about-us-intro">
                  <h2 className="heading trusted">Trusted By</h2>
              </div>                            
          </div>
          <div className="container">
              <div className="row">
                  <div className="logo-layout-1 client owl-carousel12"> 
                    <Slider {...clientsettings}>
                    {clientLogo.map((item, index)=>{
                      return(
                        <Client
                          key={index}
                          prm={{
                            name: item?.name,
                            image: `${siteUrl}${item?.logo}`
                          }}
                        />
                      )
                    })}
                    </Slider>
                  </div>
              </div>
          </div>
      </section>
    </>           
    )}
	
    <Footer/>
    </>
    
    
  )
}

export default Home